import { useGet } from '@ngt/forms';
import { useMemo } from 'react';
import { SWRConfiguration, SWRResponse } from 'swr';
import { Project, ProjectGetViewableCollectionResponse, ProjectGetViewableCollection } from '../../api/dtos';

const getData = (response?: SWRResponse<ProjectGetViewableCollectionResponse, ProjectGetViewableCollectionResponse>) => {
    return response?.data?.projects ?? [];
}
const getError = (response?: SWRResponse<ProjectGetViewableCollectionResponse, ProjectGetViewableCollectionResponse>) => (response?.error ?? response?.data)?.responseStatus;

const getAdditionalState = (response?: SWRResponse<ProjectGetViewableCollectionResponse, ProjectGetViewableCollectionResponse>) => ({
    idMap: !!response?.data?.projects?.length ? response?.data?.projects?.reduce<Record<number, Project>>((a, b) => {
        if (!b?.id) {
            return a;
        }
        
        a[b.id] = b;

        return a;
    },{}): undefined
});

const useProjects = (configuration?: SWRConfiguration<ProjectGetViewableCollectionResponse, ProjectGetViewableCollectionResponse>) => {
    
    const request = useMemo(() => {
        return () => {
            return new ProjectGetViewableCollection();
        };
    }, [configuration])

    return useGet(request, { getData, getError, getAdditionalState }, configuration);
}

export default useProjects;